module.exports = __webpack_public_path__ + "media/images/regional-image20-8fc55ec76fdffc8ef4440bef3375c45e.jpg";